<!--
    @name: 班组记工列表
    @description:
    @author: 徐朝成 xcc614@qq.com
    @time: 2021-10-29 10:12:06
-->
<template>
  <el-dialog :append-to-body="true"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             :visible.sync="show"
             center
             title="记工列表"
             width="600px">
    <div>
      <div style="margin-bottom: 20px">
        <span>{{ form.cYear }}年{{ form.cMonth }}月{{ form.cDay }}日（{{ form.IMonthCn }}{{ form.IDayCn }}）</span>
        <span>已记工 <span style="color: #409eff">{{ list.length }}</span> 笔</span>
      </div>
      <div class="contextheight">
        <div v-for="(items,index) in list"
             :key="index"
             class="context">
          <div v-for="(item,i) in items" :key="i">
            <div class="rowtitle">
              <span>在 {{ item.projectName }} 对 {{item.workerName}} 记了一笔{{ ['', '点工', '包工(按量记)'][item.recordType] }}</span>
              <span v-if="item.salary"
                    style="color: #FF6600;font-size: 16px;float: right">￥{{ item.salary }}元</span>
            </div>
            <div class="rowcontext">
              <div v-if="item.recordType!=2">
                <span style="color: #666666">上班：</span>{{ item.workType != 3 ? item.workDuration : '' }}{{
                  ['', '个工', '个工', '休息', '小时'][item.workType]
                }}
              </div>
              <div v-if="item.recordType!=2">
                <span style="color: #666666">加班：</span>{{
                  item.haveWorkOvertime == 2 ? `${item.workOvertimeDuration}小时` : '无加班'
                }}
              </div>
            </div>
          </div>
          <div style="text-align: right;border-top: 1px solid #E4E7ED;padding: 11px 20px;line-height: 1em">
            <el-button size="small"
                       type="text"
                       @click="edit(items)">编辑
            </el-button>
            <el-button size="small"
                       style="color: #FF6600"
                       type="text"
                       @click="del(items[0])">删除
            </el-button>
          </div>
        </div>
      </div>
      <div style="text-align: center;margin: 20px 0">
        <el-button type="primary"
                   @click="add">添加记工
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {api} from "@/api/apiRecord"

export default {
  name: "dayLogList",
  components: {
  },
  data(){
    return {
      show:false,
      list:[],
      loading:false,
      form:{},
      type:this.$route.query.type?this.$route.query.type:1,//当前页面进入模式1.个人记工2.班组记工
    }
  },
  methods:{
    open(form){
      this.form=form;
      this.show=true;
      this.getList();
    },
    //获取指定时间记工流水
    async getList(){
      let obj={
          day:this.form.cDay,
          month:`0${this.form.cMonth}`.substr(-2),
          year:`0${this.form.cYear}`.substr(-2),
          projectNo:this.form.projectNo,
          type:this.type
        };
      let res=await api.workRecords(obj);
      if(res.data.code==200){
        //按工人分组
        let obj={};
        res.data.data.map(v=>{
          !obj[v.operateNum]&&(obj[v.operateNum]=[])
          obj[v.operateNum].push(v)
        })
        let list=[];
        for(let i in obj){
          list.push(obj[i])
        }
        this.list=list;
      }
    },
    //添加记工
    add(){
      this.$parent.$refs.statisticsBtn.day=this.form;
      this.$parent.$refs.statisticsBtn.selectStatisticsType=true
    },
    //编辑记工
    edit(item){
      this.$parent.$refs.statisticsBtn.openarr(item)
    },
    //删除记工
    del(item){
      this.$message.tips('确定删除该笔记工吗？',async (v)=>{
        if(v){
          let res;
          if(item.recordType==1)res=await api.workRecordDelBZ(item.operateNum);//点工
          if(item.recordType==2)res=await api.workWrapdsDelBZ(item.operateNum);//包工
          if(res.data.code==200){
            this.$message.success(res.data.msg);
            this.$parent.getprojectlist(this.form.projectNo);
          }else{
            this.$message.error(res.data.msg);
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.contextheight{
  max-height: 500px;
  overflow-y: auto;
}
.context{
  border: 1px solid #E4E7ED;
  border-radius: 2px;
  margin-bottom: 20px;
  .rowtitle{
    flex: 1;
    background: #F5F7FA;
    color: #333333;
    font-size: 14px;
    line-height: 40px;
    padding: 0 10px;
  }
  .rowcontext{
    display: flex;
    font-size: 14px;
    color: #333333;
    line-height: 60px;
    padding: 0 10px;
    div{
      flex: 1;
      display: inline-block;
    }
  }
}
/deep/.el-button--small{
  font-size: 14px;
}
/deep/ .el-dialog__body {
  padding: 20px 25px;
}
.el-button--primary {
  color: #fff;
  border-color: #b79255;
  background: #b79255;
  padding: 8px 15px;
  font-size: 14px;
  &:hover,&:focus{
  color: #fff;
  border-color: #b79255;
  background: #b79255;
  }
  }
</style>
